const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '基本信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '公示信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '公示内容',
        },
    },
    {
        component: 'html-reader',
        options: {
            data: '',
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '附件',
        },
    },
    {
        component: 'file-list',
        options: {
          groupId: '',
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '通知书',
        },
    },
    {
        component: 'ZlmTabDetail',
        options: {
            title: '候选人',
            data: {},
        },
    },
    // 后端说暂时没有返回这部分数据
    // {
    //     component: 'ZlmTitle',
    //     options: {
    //         size: 'medium',
    //         text: '审核记录',
    //     },
    // },
    // {
    //     component: 'ZlmTabDetail',
    //     options: {
    //         title: '记录',
    //         data: [],
    //     },
    // },
]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/app/track/dbOverview`, {
                bdGuid: this.$route.query.id,
                ggBdGuid: this.$route.query.ggBDGuid,
            }, { showLoading: true }).then((res) => {
                if (!res.data.dbZhongBiaoJieGuoGuid) {
                    return
                }
                this.getZbjggsDetail(res.data.dbZhongBiaoJieGuoGuid)
            })
        },
        getZbjggsDetail(guid) {
            this.$request.post(`/transformToAfter/app/determine/bid/ZbjggsInfoView`, {
                bdGuid: this.$route.query.id,
                guid: guid,
            }).then((res) => {
                console.log(res)
                if (res.data && res.data.rows) {
                    const rows = res.data.rows
                    this.config[1].options.data = {
                        '标段名称': rows.bdName,
                        '标段编号': rows.bdBH,
                        '项目类型': getProjectTypeName(rows.zbxmlx),
                        '采购方式': getPurchaseTypeName(rows.cgFangShi),
                        '供应商总数': rows.gysCount,
                        '中标供应商': rows.zbgysCount,
                    }
                    this.config[3].options.data = {
                        '公示名称': rows.gongshiName,
                        '公示开始时间': this.$util.timeFormatter(rows.gongShiStartTime),
                        '公示结束时间': this.$util.timeFormatter(rows.gongShiEndTime),
                        // '公示内容': getProjectTypeName(rows.zbxmlx),
                        '是否对外公示': rows.isOutGongShi === '1' ? '是' : '否',
                        // '附件': rows.gysCount,
                    }
                    this.config[5].options.data = rows.gongShiContent
                    this.config[7].options.groupId = rows.fujianGuid
                    if (rows.jggsList && rows.jggsList.length > 0) {
                        this.config[9].options.data = rows.jggsList.map((t) => ({
                            '中标候选人': t.tbrName,
                            '是否中标': t.isZhongBiao ? '是' : '否',
                            '中标金额': t.zhongBiaoJia + t.chengJiaoDanWei,
                            // '公示名称': '',
                            // '公示开始时间': '',
                            // '公示结束时间': '',
                            // '备注': '',
                            // '是否对外公示': '',
                            // '附件': '',
                        }))
                    }
                }
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
